import { emDashUnicode } from "@gsa/afp-shared-form-utils";
import './shipping-calculation-readonly.scss';

export default function ShippingCalculationReadonlyModifier({
    base,
    additional,
    extended,
} = {}) {
    return (
        <div className="shipping-calculation-readonly">
            <strong>Shipping days</strong>
            <hr />
            <div className="shipping-calculation-readonly__item">
                <span className="label">Base:</span>
                <span className="value">{base || emDashUnicode}</span>
            </div>
            <div className="shipping-calculation-readonly__item">
                <span className="label">Additional:</span>
                <span className="value">{additional || emDashUnicode}</span>
            </div>
            <div className="shipping-calculation-readonly__item">
                <span className="label">Extended:</span>
                <span className="value">{extended || emDashUnicode}</span>
            </div>
            <hr />
            <div className="shipping-calculation-readonly__item">
                <span className="label"><strong>Total:</strong></span>
                <span className="value"><strong>{((parseInt(base) || 0) + (parseInt(additional) || 0) + (parseInt(extended) || 0)) || emDashUnicode}</strong></span>
            </div>
        </div>
    );
}